import { Address } from "../model/address";

export interface AddressState {
    addresses: { [id: number]: Address };
}

export const initialAddressState: AddressState = {
    addresses: {},
};
